import React from 'react';
import { useTranslation } from 'react-i18next';
import Link from 'components/Link';
import {
  NotFoundSubtitle,
  NotFoundTitle,
  NotFoundWrapper,
  ViewAllExperiencesButton,
} from 'components/molecules/NotFoundExperienceMessage/NotFoundExperienceMessage.styled';

const NotFoundExperienceMessage = () => {
  const { t } = useTranslation();

  return (
    <NotFoundWrapper>
      <NotFoundTitle>{t('notFoundExperienceTitle')}</NotFoundTitle>
      <NotFoundSubtitle>{t('notFoundExperienceSubtitle')}</NotFoundSubtitle>
      <ViewAllExperiencesButton as={Link} to="/e">
        {t('viewAllExperiences')}
      </ViewAllExperiencesButton>
    </NotFoundWrapper>
  );
};

export default NotFoundExperienceMessage;
